import { Box, Button, CardInfo, Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface NewCardProps {
  openNewCardModal: () => void
}

const NewCard = ({ openNewCardModal }: NewCardProps) => {
  return (
    <CardInfo>
      <Box style={{ height: '100%' }} alignItems="center" gap="s16" justifyContent="center">
        <Box
          width="s96"
          height="s64"
          paddingY="s8"
          paddingX="s12"
          flexDirection="columnReverse"
          alignItems="flexEnd"
          boxShadow="s400"
          background="radicalRed1000"
          borderRadius={{ all: 'abs008' }}
        >
          <Box width="s24" flexDirection="rowReverse">
            <Icon.Large icon="logo-avatar" color="grey000White" />
          </Box>
        </Box>
        <Button type="secondary" onClick={openNewCardModal} iconName="add">
          {i18n.t('it_management.software_setups.cards.actions.create_card')}
        </Button>
      </Box>
    </CardInfo>
  )
}

export default NewCard
